// Card color definitions for A-T (20 cards)
// Based on casino keno machine color schemes
export const cardColors = {
  A: '#FF6B9D', // Pink
  B: '#4169E1', // Royal Blue
  C: '#32CD32', // Lime Green
  D: '#FF4500', // Orange Red
  E: '#FFD700', // Gold
  F: '#9370DB', // Medium Purple
  G: '#00CED1', // Dark Turquoise
  H: '#FF69B4', // Hot Pink
  I: '#87CEEB', // Sky Blue
  J: '#98FB98', // Pale Green
  K: '#FFA500', // Orange
  L: '#00FF00', // Lime
  M: '#FF1493', // Deep Pink
  N: '#FFD700', // Gold
  O: '#00BFFF', // Deep Sky Blue
  P: '#DA70D6', // Orchid
  Q: '#FFA07A', // Light Salmon
  R: '#FF6347', // Tomato
  S: '#FFDAB9', // Peach Puff
  T: '#FFE4B5'  // Moccasin
};

// Get contrasting text color based on background
export const getTextColor = (bgColor) => {
  // Convert hex to RGB
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? '#000000' : '#000000';
};
